import React from 'react';
import {  
    Options,
    Transportadora
} from './styled';
import {Button} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../../../services/api';
import {GridColDef, GridRowData, GridToolbarDensitySelector, GridToolbarFilterButton} from '@material-ui/data-grid';
import Table from '../../../components/Table';
import Container from '../../../components/Container';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import { default as MaterialUiAlert } from '@material-ui/lab/Alert';
import { UserContext } from '../../../UserContext';
import SubjectIcon from '@material-ui/icons/Subject';
import { Header } from '../../Repository/Show/styled';
import useForm from '../../../hooks/useForm';
import Input from '../../../components/Form/Input';
import SearchIcon from '@material-ui/icons/Search';
import TimerIcon from '@material-ui/icons/Timer';
import { CanhotosProps, QuickSearchToolbarProps } from '../../../interfaces';
import Alert from '../../../components/Alert';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
        button: {
            marginRight: 20,
            marginBottom: 5,
            marginTop: 5,
        },
        step: {
            backgroundColor: 'transparent'
        },
    }),
);

const columns: GridColDef[] = [
    {field: 'col1', headerName: 'ID', width: 90},
    {
        field: "col2",
        headerName: "Situação",
        sortable: false,
        width: 250,
        align: 'center',
        renderCell: (params) => {
            return (
                <>
                    {params.value === 'Pendente' ? 
                        <MaterialUiAlert style={{width: '100%'}} severity="warning">{params.value}</MaterialUiAlert> : params.value === 'Aguardando Conferência' ? 
                        <MaterialUiAlert style={{width: '100%'}} severity="warning" iconMapping={{ warning: <TimerIcon fontSize="inherit" /> }}>{params.value}</MaterialUiAlert>
                    
                    : params.value === 'Rejeitado' ?  <MaterialUiAlert style={{width: '100%'}} severity="error">{params.value}</MaterialUiAlert> : <MaterialUiAlert style={{width: '100%'}} severity="success">{params.value}</MaterialUiAlert>}
                </>
            );
        }
    },
    {
        field: "col3",
        headerName: "Situação Envio",
        sortable: false,
        width: 170,
        align: 'center',
        renderCell: (params) => {
            return (
                <>
                    {params.value === 'Pendente' ? 
                        <MaterialUiAlert style={{width: '100%'}} severity="warning">{params.value}</MaterialUiAlert>
                    
                    : <MaterialUiAlert style={{width: '100%'}} severity="success">{params.value}</MaterialUiAlert>}
                </>
            );
        }
    },
    {field: 'col4', headerName: 'Tipo', width: 105},
    {field: 'col5', headerName: 'CTE', width: 390},
    {field: 'col6', headerName: 'Numero', width: 130,},
    {field: 'col7', headerName: 'Série', width: 110,},
    {field: 'col8', headerName: 'Emissão', width: 130},   
    {field: 'col9', headerName: 'QDT', width: 110},
    {field: 'col10', headerName: 'Valor Total', width: 150, align: 'right'},
    {field: 'col11', headerName: 'Data Cadastro', width: 200},
    {field: 'col12', headerName: 'PKTransportadora', width: 200, hide: true},
    {field: 'col13', headerName: 'iTipo', width: 200, hide: true},
];

function QuickSearchToolbar(props: QuickSearchToolbarProps) {
    const classes = useStyles();
  
    return (
      <div className={classes.root}>
        <div>
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
        </div>        
      </div>
    );
}

const Main: React.FC = () => {
    document.title = "Controle de Frete - Sultan Veste a Casa";

    const {setLoading, data} = React.useContext(UserContext);

    const [rows, setRows] = React.useState<GridRowData[]>([]);
    const [selected, setSelected] = React.useState<any>();
    const [success, setSuccess] = React.useState('');
    const [error, setError] = React.useState('');

    const classes = useStyles();   
    const navigate = useNavigate();

    const cnpj = useForm('cnpj');

    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',    
    });    
    
    React.useEffect(() => {
        getCanhotos();        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCanhotos = async () => {
        try{
            setLoading(true);

            const {data} = await api.get('freight-control');

            const canhotosData = data.documentos.map((el: CanhotosProps, index: number) => {
                return {
                    id: index,
                    col1: el.PK,
                    col2: el.sDescSituacao,
                    col3: el.sDescSituacaoEnvio,
                    col4: el.sDescTipo,
                    col5: el.sChaveCTe ? el.sChaveCTe : 'Não é necessário para esse documento.',
                    col6: el.iNumero,
                    col7: el.sSerie,
                    col8: moment(el.dtDataEmissao).format('DD/MM/YYYY'),                   
                    col9: el.iQtdeCanhotos,
                    col10: formatter.format(parseFloat(el.nValorTotal)),  
                    col11: moment(el.dtUsoarioCadastro).format('DD/MM/YYYY'),  
                    col12: el['nfe.dbo.Transportadora_ObjectDisplay'],
                    col13: el.iTipo,
                }
            });

            setRows(canhotosData);
        }catch(error){
            setError(error.message);
        }finally{
            setLoading(false);
        }
    }    

    const onSelectedHandle = (id: string) => {
        setSelected(id);
    }

    function cnpjCpfMask(value: string) {
        var maskCpfCnpj;

        if (value.length >= 15) {
            maskCpfCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
        } else {
            maskCpfCnpj = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,];
        }

        return maskCpfCnpj;

    }

    const mudarTransportadora = async (e: React.FormEvent) => {
        e.preventDefault();

        try{
            setLoading(true);

            await api.post('/transportadora/edit', {
               CNPJ: cnpj.value 
            });          
            
            setSuccess('Transportadora alterada com sucesso!');
        }catch(error){
            setError(error.message);
        }finally{
            setLoading(false);
            getCanhotos();            
        }
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    return (
        <Container>   
            {['100', '101', '105'].includes(`${data.PKGrupo}`) &&
                <Transportadora>
                    <h3>Deseja ver como outra Transportadora ? Digite o CNPJ abaixo:</h3>
                    <form onSubmit={mudarTransportadora} className="ds-flex align-items-start">
                        <Input
                            required
                            mask={cnpjCpfMask(cnpj.value)} 
                            autoComplete="off"
                            id="cpf_or_cnpj" 
                            type="text" {...cnpj}
                            placeholder="CNPJ Transportadora"
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<SearchIcon />}
                            type="submit"
                        >
                            PESQUISAR
                        </Button> 
                    </form>
                </Transportadora>
            }            
            <Header>
                <Options>
                    <Link to={`${process.env.PUBLIC_URL}/usuario/controle-de-frete/opcoes`}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.button}
                            startIcon={<AddIcon />}
                        >
                            ADICIONAR NOVO
                        </Button> 
                    </Link>  
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.button}
                        disabled={!selected}
                        startIcon={<SubjectIcon />}
                        onClick={() => navigate(`anexar/${selected.row.col13}/${selected.row.col12}/${selected.row.col1}`)}
                    >
                        VER ITENS {!selected && '(Selecione uma linha)'}
                    </Button> 
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.button}
                        disabled={!selected}
                        startIcon={<EditIcon />}
                        onClick={() => navigate(`editar/${selected.row.col13}/${selected.row.col12}/${selected.row.col1}`)}
                    >
                        EDITAR {!selected && '(Selecione uma linha)'}
                    </Button>                 
                </Options>  
            </Header>                               
            <Table 
                rows={rows} 
                columns={columns} 
                components={{ Toolbar: QuickSearchToolbar }}
                onClick={onSelectedHandle}
            />           
          
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                    
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                        
        </Container>
    );
};

export default Main;